import { useState } from "react";

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);

  const toggle = () => {
    setIsShowing((prevState) => !prevState);
  };

  return {
    isShowing,
    toggle,
  };
};

export default useModal;
